function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.333 10a1.333 1.333 0 001.334-1.333v-6a1.333 1.333 0 00-1.334-1.334h-3.06a.667.667 0 01-.466-.193L6.86.193A.667.667 0 006.393 0H2A1.333 1.333 0 00.667 1.333v7.334A1.333 1.333 0 002 10h9.333zM5 2a1 1 0 110 2 1 1 0 010-2zm6.333 6.333a.333.333 0 01-.333.334H2.333A.333.333 0 012 8.333v-.226c0-.074.026-.145.073-.2L4 5.46a.347.347 0 01.233-.127.333.333 0 01.26.12L5.46 6.62a.327.327 0 00.402.084.34.34 0 00.118-.097l1.92-2.48a.34.34 0 01.533 0l2.834 3.78a.34.34 0 01.066.2v.226zM14 4v6a1.333 1.333 0 01-1.333 1.333H3.333a1.333 1.333 0 001.334 1.334h8A2.667 2.667 0 0015.333 10V5.333A1.333 1.333 0 0014 4z",
  fill: "#BCBCBC"
});

var SvgImageIcon = function SvgImageIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 13,
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgImageIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/image-icon.b2a6b8bd.svg";
export { ForwardRef as ReactComponent };